import { motion } from "framer-motion";
import { IMAGES, fadeIn } from "@/lib/numa-assets";

export const DeliverySystem = () => {
  return (
    <section
      id="delivery"
      data-testid="delivery-section"
      className="bg-[#F9F9F6] border-t border-[#E2E5E0] py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-12 gap-6 lg:gap-12 items-stretch">
          {/* Left: image */}
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 lg:col-span-7 aspect-[4/5] lg:aspect-auto lg:min-h-[680px] relative overflow-hidden bg-[#F0F2EF]"
            data-testid="delivery-image-wrap"
          >
            <img
              src={IMAGES.capsule_macro}
              alt="Macro photograph of clear HPMC capsules with sage spray-coated mini-tabs"
              className="absolute inset-0 w-full h-full object-cover"
              data-testid="delivery-image"
            />
          </motion.div>

          {/* Right: content */}
          <motion.div
            {...fadeIn}
            className="col-span-12 lg:col-span-5 flex flex-col justify-between"
          >
            <div>
              <div className="flex items-center gap-4 mb-8">
                <span className="numa-marker">04</span>
                <span className="h-[1px] w-12 bg-[#8A9A90]" />
                <span className="numa-marker text-[#152219]">
                  Delivery System
                </span>
              </div>
              <h2
                className="font-heading text-4xl sm:text-5xl lg:text-[56px] tracking-[-0.025em] font-medium text-[#152219] leading-[1.04]"
                data-testid="delivery-title"
              >
                Precision
                <br />
                micro-tab system.
              </h2>
              <p className="text-[15px] leading-[1.7] text-[#57635A] mt-8 max-w-md">
                NUMA-05 is built on a system of precisely manufactured
                mini-cores — each measuring less than 2mm — finished with a
                protective coating engineered to help resist exposure to the
                acidic environment of the stomach.
              </p>
            </div>

            <div className="mt-16 border-t border-[#E2E5E0]">
              {[
                ["Mini-core size", "< 2 mm"],
                ["Coating", "Acid-resistant"],
                ["Serving", "2 capsules daily"],
                ["Testing", "Third-party verified"],
              ].map(([k, v]) => (
                <div
                  key={k}
                  className="flex items-center justify-between py-5 border-b border-[#E2E5E0]"
                  data-testid={`delivery-spec-${k.toLowerCase().replace(/\s/g, "-")}`}
                >
                  <span className="text-[11px] tracking-[0.22em] uppercase text-[#8A9A90]">
                    {k}
                  </span>
                  <span className="font-heading text-[15px] text-[#152219] tracking-tight">
                    {v}
                  </span>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default DeliverySystem;
